import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { TableButton } from '../../../_models/table-buttons';
import { DocumentsService } from 'src/app/_services/documents.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-table-buttons-wrapper',
  templateUrl: './table-buttons-wrapper.component.html',
  styleUrls: ['./table-buttons-wrapper.component.scss']
})
export class TableButtonsWrapperComponent implements OnInit, OnDestroy {
  checkedDocs: Array<Object> = [];
  allowDelete: boolean = false;
  allowSign: boolean = false;
  documentReq$: Subscription = null;
  constructor(
    private documentsService: DocumentsService
  ) { }

  @Output() sendInfo = new EventEmitter<TableButton>();
  @Input() buttonsConfig: TableButton[];
  action : string;

  ngOnInit(): void {
    this.documentReq$ = this.documentsService.documents$.subscribe(data => {
      this.checkedDocs = data?.filter(d => d.checked) || [];
      this.allowDelete = 
              this.checkedDocs.filter(d => d['SignType'].DeleteRequired == true  
              || d['Signed']).length > 0;

           /// por nominado
      this.allowSign = this.checkedDocs.filter(d => d['Nominated'] || !d['Signed']).length > 0;
    });
  }

  ngOnDestroy() {
    if (this.documentReq$) {
      this.documentReq$.unsubscribe();
    }
  }

  public sendButtonInfo(btn): void {
    const btnInfo: TableButton = btn;
    this.sendInfo.emit(btn);
  }

  public configButton(btn: TableButton) {
    let enable: boolean = false;
    switch (btn.action) {
      case 'sign':
        enable = this.allowSign;
        this.action = this.checkedDocs.filter(d => d['Nominated'] && d['Signed']).length > 0 ? "view" : btn.action;
        break;
      case 'delete':
        enable = this.allowDelete;
        this.action = btn.action;
        break;
      default:
        enable = this.checkedDocs && this.checkedDocs.length > 0;
        this.action = btn.action;
        break;
    }
    return !enable;
  }

}
